<div class="col-xl">
  <div class="card-wrapper card-space">
    <div class="card card-bg">
      <div class="card-body">
        <div class="container">
            <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/home">Home</a><span class="separator">/</span></li>
                <li class="breadcrumb-item active"><a href="javascript:void(0)">Impostazioni notifiche</a></li>
              </ol>
            </nav>
          <div class="row justify-content-center">
            <div class="col-12 col-lg-12">
              <h3 class="card-title h4" jhiTranslate="impostazioniNotifiche.impNotifiche">Impostazioni Notifiche</h3>
              <div class="border-black border-top">
              </div>
            </div>
          </div>
          <div class="justify-content-center d-flex mt-5">
            <div class="col-12 col-lg-8">
              <div class="card card-bg shadow">
                <div class="card-body">
                  <h4 class="card-title h4" style="color: #0066CC">Email
                    <img src="./content/svg/icon-e-mail-19.jpg" alt="email" class="icon icon-lg justify-content-center"
                         style="position: absolute; right: 50px"/>
                  </h4>
                  <div class=" border-top border-primary" *ngIf="windowSize > 640">
                  </div>
                  <div class="row">
                    <div class="toggles">
                      <div class="form-check col-12">
                        <label for="Email">
                          <h5 class="mt-5 fw-bold">
                            Account: <span style="color: gray">{{userData.email}}
                            <input (change)="cambioPreferenzaON($event, 'CD-4')" type="checkbox" id="Email">
                            <span class="lever"></span>
                            </span>
                          </h5>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-bg mt-5 shadow">
                <div class="card-body">
                  <h4 class="card-title h4" style="color: #0066CC">App IO
                    <img src="./content/svg/1611576751-logo-io-app-2021.svg" alt="AppIO" class="icon icon-lg justify-content-center"
                         style="position: absolute; right: 50px"/>
                  </h4>
                  <div class="  border-top border-primary" *ngIf="windowSize > 640">
                  </div>
                  <div class="row">
                    <div class="toggles">
                      <div class="form-check col-12">
                        <label>
                          <h5 class="mt-5 fw-bold">
                            Account: <span style="color: gray">{{userData.cognome}} {{userData.nome}}
                            <input (change)="cambioPreferenzaON($event, 'CD-3')" type="checkbox" id="AppIo">
                            <span class="lever"></span>
                          </span>
                          </h5>
                        </label>
                      </div>
                    </div>
                    <span class="mt-3 fw-bold" style="color: red">
                      <svg class="icon justify-content-center icon-danger">
                        <use href="./content/svg/sprites.svg#it-warning-circle"></use>
                      </svg>
                      <span jhiTranslate="impostazioniNotifiche.ricezioneAPPIO">Per la ricezione di notifiche sull' App IO è necessario iscriversi al servizio dall'app</span>
                    </span>
                    <span class="mt-3 fw-bold" style="color: red">
                      <svg class="icon justify-content-center icon-primary">
                        <use href="./content/svg/sprites.svg#it-help-circle"></use>
                      </svg>
                      <a [href]="'https://io.italia.it/'" class="fw-bold"
                         style="color: #0066CC;" jhiTranslate="impostazioniNotifiche.ulterioriInformazioni">Ulteriori Informazioni</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
